import { ReactComponent as CalendarShapeIcon } from './calendar.svg';

export default CalendarShapeIcon;
